import SectionHeading from '@/components/feature/SectionHeading';

const focus = [
  { icon: 'ri-fire-line', title: '本季高热度连载', desc: '《星屑彼端的旅人》《妖精庭院物语》连续三周稳居追更榜首，适合优先放入观看列表。' },
  { icon: 'ri-parentheses-line', title: '适合一口气看完', desc: '已完结的《苍蓝食堂的午后》《夏日回声日记》无需等更，周末即可整季补完。' },
  { icon: 'ri-moon-clear-line', title: '深夜档条目说明', desc: '深夜档与里番合集条目均已标注版本与观看顺序建议，开播前可先确认版本差异。' },
];

const facts = [
  { week: '周四', time: '22:30', title: '星屑彼端的旅人', note: '本季口碑最高' },
  { week: '周六', time: '19:30', title: '妖精庭院物语', note: '画面与配乐出色' },
  { week: '周日', time: '20:00', title: '机械心脏与春日约定', note: '治愈系新番' },
  { week: '周五', time: '23:00', title: '雾之都侦探社', note: '推理单元剧' },
];

export default function SeasonOverview() {
  return (
    <section id="season" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="本季新番速览"
          title="先看一屏，就知道这季该追什么"
          desc="这里把正在更新、值得优先观看的条目按看点归类，帮你在众多新番中快速锁定第一梯队，避免把时间花在反复比较上。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
          <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {focus.map((f) => (
              <article key={f.title} className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 text-xl">
                  <i className={f.icon}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg md:text-xl text-foreground-950">{f.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
              </article>
            ))}
          </div>

          <div className="lg:col-span-2 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
            <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
              <h3 className="font-heading text-lg text-foreground-950">本季更新看点</h3>
              <span className="text-xs text-foreground-500">按更新时间排列</span>
            </div>
            <ul className="divide-y divide-background-200">
              {facts.map((item) => (
                <li key={item.title} className="flex items-center gap-4 px-5 py-3.5">
                  <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-900 font-heading text-base shrink-0">
                    {item.week}
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm md:text-base font-medium text-foreground-900 truncate">{item.title}</p>
                    <p className="text-xs text-foreground-500">{item.note} · {item.time}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <aside className="rounded-lg bg-primary-500 p-6 md:p-7 text-background-50 flex flex-col justify-between dark:text-foreground-950">
            <div>
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-background-50/20 text-2xl">
                <i className="ri-calendar-check-line"></i>
              </span>
              <h3 className="mt-4 font-heading text-xl md:text-2xl leading-snug">一天看几集更合适？</h3>
              <p className="mt-3 text-sm leading-relaxed text-background-50/90">
                追更连载建议每天控制在 2 集以内，既不容易串味也能保持新鲜感；补番则适合以 6 集为一组，按档期循序渐进。
                页面下方的追番时间表已按星期整理更新时间，可据此安排每日节奏。
              </p>
            </div>
            <a
              href="#schedule"
              className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-background-50 hover:underline whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
              查看每周追番安排
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}